<template >
     <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit_sms_price" id="settings_sms_price_form">
              <kt-form-section >
               <p class="pb-3">
                    {{ $t('notification.label.sms_price_title') }}
                </p>
            <kt-row >
                <kt-form-group class="col-12 col-sm-4 col-md-3">
                    <kt-form-label for="sms_price">
                        {{ $t('notification.label.sms_price')+  ' ('  +  $t('label.rial') + ')'}}
                    </kt-form-label>
                    <kt-form-control
                        dir="rtl"
                        data-id="0"
                        name="sms_price"
                        placeholder="قیمت را به ریال وارد کنید"
                        v-model="form_data.sms_price"
                    >
                    </kt-form-control>
                </kt-form-group>
                <kt-form-group class="col-12 col-sm-4 col-md-3">
                    <kt-form-label for="sms_price">
                        {{ $t('notification.label.setTerminalForPay')}}
                    </kt-form-label>
                    <select
                        name="recharge_gateway_id"
                        id="recharge_gateway_id"
                        v-model="form_data.recharge_gateway_id"
                        class="form-control kt-selectpicker"
                    >
                        <option>{{ $t('selectpicker.nothing') }}</option>
                        <option
                            v-bind:key="index"
                            v-for="(gateway, index) in gateways"
                            v-bind:value="gateway.id"
                            :selected="gateway.id === form_data.recharge_gateway_id"
                        >
                            {{ gateway.farsi_name }}
                        </option>
                    </select>
                </kt-form-group>
                <kt-form-action class="mt-4">
                      <kt-button
                            class="m-2"
                            size="md"
                            variant="success"
                            type="submit"
                            id="submit_btn_sms_price"
                      >
                        {{ $t('btn.update') }}
                    </kt-button>
                </kt-form-action>
            </kt-row>
            </kt-form-section>
           </form>
        </kt-panel-body>
     </kt-panel>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";

export default {
    name:'setSmsPrice',
    props: {
        submit_sms_price: {
            default: () => {},
            type: Function
        },
         form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    computed: {
        ...mapGetters('collective', [
            'gateways'
        ]),
    },
    methods: {
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)
        },
    },
    mounted() {
        this.afterDispatch()
        this.$store.dispatch('collective/fetch')
    }
}
</script>
<style scoped>

</style>